import ExamTabs from '../components/ExamTabs';
import { Box } from '@mantine/core';

function Study({ onLogout, user }) {
  return (
    <Box>
      <ExamTabs user={user} />
    </Box>
  );
}

export default Study;
